import React, { FC, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Col, Image, Row, Button, Result, Form } from 'antd'
import logo from 'Assets/Images/logo-compulog.svg'
import { InputText } from 'Components/Form'
import Loading from 'Components/Loading'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { authentication } from 'Routes'
import AuthService from 'Services/UAA'
import * as yup from 'yup'

import { FormAuth } from '../styles'

interface IFormInput {
  cpfOuEmail: string
}

const RecoverPassword: FC = () => {
  const navigate = useNavigate()
  const [result, setResult] = useState<number>(0)
  const hookForm = useForm()

  const onSubmit = async (values: IFormInput) => {
    if (!values.cpfOuEmail.indexOf('@')) {
      await AuthService.RecoverPasswordInit(values.cpfOuEmail)
    } else {
      await AuthService.RecoverPasswordInit(undefined, values.cpfOuEmail)
    }
  }

  return hookForm.formState.isSubmitting ? (
    <Loading />
  ) : (
    <>
      {result === 200 ? (
        <Result
          status="success"
          subTitle="Um email com o link para você criar uma nova senha foi enviado para seu email"
          extra={[
            <Button
              type="primary"
              key="console"
              onClick={() => navigate(authentication.login)}
            >
              Voltar para o login
            </Button>,
          ]}
        />
      ) : null}

      {result === 0 ? (
        <FormAuth name="login" layout="vertical">
          <Col>
            <Row justify="start">
              <Image
                height={60}
                width={220}
                preview={false}
                id="form-login-logo"
                src={logo}
              />
            </Row>
            <Row>
              <InputText
                methods={hookForm}
                scope="login"
                name="cpfOuEmail"
                label="CPF"
                type="masked"
                mask="111.111.111-11"
              />
            </Row>

            <Row justify="space-between" align="top">
              <Button
                id="form-login-button"
                disabled={hookForm.formState.isSubmitting}
                color="primary"
                type="primary"
                onClick={hookForm.handleSubmit(onSubmit)}
              >
                Recuperar Senha
              </Button>
            </Row>
          </Col>
        </FormAuth>
      ) : null}
    </>
  )
}

export default RecoverPassword

//   return (
//     <form id='form-login' noValidate onSubmit={formik.handleSubmit}>
//       <Grid container>
//         <Grid  className={classes.form_control}  item xs={12} xl={12}>
//           <Logo id="form-login-logo" src={logo} />
//         </Grid>
//         <Grid className={classes.form_control}  item xs={12} xl={12}>
//           <TextField
//           fullWidth
//           size="small"
//           scope='form-login'
//           label='CPF'
//           className="darkmode"
//           name='cpf'
//           type='text'
//           formik={formik}
//           mask='cpf'
//           />
//         </Grid>

//         <Grid item  xs={4} xl={4}>
//           <Button
//           id="form-login-button"
//           className={classes.btn_login}
//           variant='contained'
//           color='primary'
//           type='submit'
//           disabled={formik.isSubmitting}>
//             Enviar
//           </Button>
//         </Grid>
//         <Grid className={classes.form_control}  item xs={12} xl={12}>
//           {SuccessRecover ? <Typography>.</Typography> : ''}
//         </Grid>

//         <Grid className={classes.form_control}  item  xs={12} xl={12}>
//           {formik.isSubmitting && <LinearProgress color='primary' />}
//         </Grid>
//       </Grid>
//     </form>
//   );
// };

// export default ;
